export const getUserDisplayName = (user) =>
  user ? [user.firstName, user.lastName].filter(Boolean).join(" ") : null;

export const buildUserNamesById = (users = []) =>
  users.reduce((namesById, user) => {
    const userName = getUserDisplayName(user);

    if (!userName) return namesById;

    namesById[`${user.id}`] = userName;
    return namesById;
  }, {});

export const getFallbackUserName = (userId) => `User ${userId}`;
